// extracted by mini-css-extract-plugin
export default {"root":"InputSearch__root--SnTcG","results":"InputSearch__results--yHq7o"};